import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';

// Components
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ZihinMimariChat } from './components/ZihinMimari';
import { SocialProofWidget } from './components/GrowthWidgets';
import { ScrollToTop } from './components/ScrollToTop';
import { CookieConsent } from './components/CookieConsent';

// Pages
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import PortfolioPage from './pages/PortfolioPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import MethodologyPage from './pages/MethodologyPage';
import AifabricPage from './pages/AifabricPage';
import GrowthSystemsPage from './pages/GrowthSystemsPage';
import SystemDetailPage from './pages/SystemDetailPage';
import KVKKPage from './pages/KVKKPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import GrowthJourneyPage from './pages/GrowthJourneyPage';

function App() {
  return (
    <div className="App bg-[#0A0A0A] min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/portfolyo" element={<PortfolioPage />} />
          <Route path="/proje/:slug" element={<ProjectDetailPage />} />
          <Route path="/metodoloji" element={<MethodologyPage />} />
          <Route path="/aifabric" element={<AifabricPage />} />
          <Route path="/buyume-sistemleri" element={<GrowthSystemsPage />} />
          <Route path="/buyume-sistemleri/:slug" element={<SystemDetailPage />} />
          <Route path="/kvkk" element={<KVKKPage />} />
          <Route path="/gizlilik" element={<PrivacyPage />} />
          <Route path="/kullanim-sartlari" element={<TermsPage />} />
          <Route path="/buyume-yolculugu" element={<GrowthJourneyPage />} />
          {/* 404 - Tüm eşleşmeyen rotalar için */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        
        {/* Global Widgets */}
        <ZihinMimariChat />
        <CookieConsent />
        
        <Toaster 
          position="bottom-right" 
          theme="dark"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid #27272A',
              color: '#fff',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
